import { Component } from '@angular/core';
import { formatInTimeZone } from 'date-fns-tz';

// Preserve moment.utc() semantics for date strings that lack a timezone designator:
// moment.utc('2024-01-15T12:00:00') treats the string as UTC, whereas
// `new Date('2024-01-15T12:00:00')` interprets it as local time.
const toUtcDate = (d: unknown): Date => {
  if (d instanceof Date) return d;
  const s = String(d);
  return new Date(/[Z]|[+-]\d{2}:?\d{2}$/.test(s) ? s : s + 'Z');
};
import { FileNotificationService } from 'src/app/Service/file-notification.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.css'],
    standalone: false
})
export class NotificationsComponent {
  notificationsData: any;
  currentPage: number = 1;
  itemsPerPage: number = 12;

  constructor(private fSerivce: FileNotificationService) {
    const data = { displayType: 1, intervalTime: -10 };
    this.fSerivce.GetFileNotifications(data).subscribe((data) => {
      this.notificationsData = {
        ...data,
        data: data.data.sort((a, b) => new Date(b.createDate).getTime() - new Date(a.createDate).getTime())
      };
    })
  }

  getConvertedDate(date: any) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return formatInTimeZone(toUtcDate(date), userTimeZone, 'dd MMM yyyy, h:mm a');
  }


  getTotalPages() {
    return Math.ceil(this.notificationsData.data.length / this.itemsPerPage);
  }

  onPageChange(page: number) {
    this.currentPage = page;
  }
}
